import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {makeApiCall} from "../../hooks/CancellableApiCall";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {DialogActions, DialogContent} from "@mui/material";

interface DeleteResourcePromptProps {
    id: number,
    divisionIdentifier: string,
}

export default function DeleteResourcePrompt(props: DeleteResourcePromptProps) {
    const [open, setOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        setDeleting(true)
        makeApiCall({
            url: `/api/resource/${props.divisionIdentifier}/${props.id}`,
            method: "DELETE",
            onLoadedCallback: () => {
                setOpen(false)
                window.location.href = `/resources/${props.divisionIdentifier.replaceAll("_", "-")}`
            },
            onError: () => {
                setDeleting(false)
                handleClose()
            }
        })
    }

    return (
        <React.Fragment>
            <DeleteForeverIcon color={"error"} onClick={() => setOpen(true)} sx={{cursor: "pointer"}}/>
            <Dialog open={open} onClose={handleClose}>
                <DialogContent>Delete Resource (This CANNOT be undone)</DialogContent>
                <DialogActions>
                    <Button color={"success"} onClick={handleClose} disabled={deleting}>Cancel</Button>
                    <Button color={"error"} onClick={handleDelete} disabled={deleting}>
                        {deleting ? "Deleting..." : "Delete Resource"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
